import React from 'react';
import wixService from '../../../../../../services/wixService';
import { WixRicosViewerNext } from '@wix/ricos-viewer';
import { ensureRicosContent , ensureDraftContent } from 'ricos-content/libs/converters';
import { fromDraft, toDraft } from 'ricos-content/libs/migrateSchema';

import { pluginLink } from 'wix-rich-content-plugin-link/viewer';
import { pluginImage } from 'wix-rich-content-plugin-image/viewer';
import { pluginVideo } from 'wix-rich-content-plugin-video/viewer';
import { pluginIndent } from 'wix-rich-content-plugin-indent/viewer';
import { pluginGiphy } from 'wix-rich-content-plugin-giphy/viewer';
import { pluginMap } from 'wix-rich-content-plugin-map/viewer';
import { pluginLineSpacing } from 'wix-rich-content-plugin-line-spacing/viewer';
import { pluginLinkPreview } from 'wix-rich-content-plugin-link-preview/viewer';
import { pluginEmoji } from 'wix-rich-content-plugin-emoji/viewer';
import { pluginFileUpload } from 'wix-rich-content-plugin-file-upload/viewer';
import { pluginVerticalEmbed } from 'wix-rich-content-plugin-vertical-embed/viewer';
import { pluginDivider } from 'wix-rich-content-plugin-divider/viewer';
import { pluginHtml } from 'wix-rich-content-plugin-html/viewer';
import { getMediaFileType, MediaType } from './getMediaFileType';
import { pluginAudio } from 'wix-rich-content-plugin-audio/viewer';
import { pluginGallery } from 'wix-rich-content-plugin-gallery/viewer';
import { pluginLinkButton } from 'wix-rich-content-plugin-button/viewer';
import { pluginTable } from 'wix-rich-content-plugin-table/viewer';
import { pluginTextColor } from 'wix-rich-content-plugin-text-color/viewer';

class RCV extends React.Component {
  idContainsPrefix = (id) => {
    return id.includes('/');
  };

  getDomain = (mediaType, metaSiteId) =>
    ({
      picture: 'static.wixstatic.com',
      video: 'video.wixstatic.com',
      music: 'music.wixstatic.com',
      document: `${metaSiteId}.usrfiles.com`,
      archive: `${metaSiteId}.usrfiles.com`,
    }[mediaType]);

  resolveFileUrl =
    () =>
    ({ id, type, privacy, url }) => {
      if (privacy !== 'private' && this.idContainsPrefix(id)) {
        const { metaSiteId } = wixService.getAppIds();
        const domain = this.getDomain(getMediaFileType(type), metaSiteId);
        return Promise.resolve(`https://${domain}/${id}`);
      }
      //  return this.getDownloadUrl()(id).then(urls => Array.isArray(urls) && urls[0]?.path);
    };

  render() {
    const locale =
      this.props.textAlignment === 'right'
        ? 'he'
        : window.initialState.lang !== 'en'
        ? window.initialState.lang
        : window.Wix.Utils.getLocale();

    const biSettings = {
      consumer: '[wix-labs] faq-client-v3 widget',
      usage: this.props.usage,
    };

    const { content } = this.props;

    const draftContent = ensureDraftContent(content);
    const validContent = toDraft(fromDraft(draftContent, {ignoreUnsupportedValues: true}));

    return (
      <WixRicosViewerNext
        textAlignment={this.props.textAlignment}
        plugins={[
          pluginLink({
            disableAutoLink: true,
            onClick: (event, url) => {
              console.log('63 ===> url = ', url);

              if (url.type === 'AnchorLink') {
                event.preventDefault();
                if (
                  url.anchorDataId === 'SCROLL_TO_TOP' ||
                  url.anchorDataId === 'SCROLL_TO_BOTTOM'
                ) {
                  window.Wix.navigateToAnchor(url.anchorDataId);
                } else {
                  window.Wix.getCurrentPageAnchors(function (anchors) {
                    const compId = anchors.find(
                      (x) => x.title === url.anchorName,
                    ).id;
                    window.Wix.navigateToAnchor(compId);
                  });
                }
              } else if (url.type === 'pageLink') {
                window.Wix.navigateToPage(url.id);
              } else if (url.type === 'DocumentLink') {
                let link = `http://media.wix.com/${url.docId}`;
                const { metaSiteId } = wixService.getAppIds();
                const type = getMediaFileType(url.docId);

                // const isPdf = url.docId.split('.').pop()?.toLowerCase() === 'pdf';

                if (type === MediaType.DOCUMENT) {
                  let ugd = 'ugd/';
                  if (url.docId.startsWith('ugd/')) {
                    ugd = '';
                  }
                  link = `http://${metaSiteId}.usrfiles.com/${ugd}` + url.docId;
                }
                if (type === MediaType.ARCHIVE) {
                  link =
                    `http://${metaSiteId}.usrfiles.com/archives/` + url.docId;
                }
                if (type === MediaType.IMAGE) {
                  // FIXME - need to check url.docId ~mv2 ??
                  link = `http://static.wixstatic.com/media/` + url.docId;
                }
                if (type === MediaType.VIDEO) {
                  // FIXME - need to check url.docId https://video.wixstatic.com/video/974e59_37fea192a31844ffb2d0c3b509a6fe96/720p/mp4/file.mp4
                  link =
                    `http://video.wixstatic.com/video/` +
                    url.docId +
                    `/720p/mp4/file.mp4`;
                }

                console.log('115 ===> link = ', link);
                window.open(link);
              }
              if (url === '#viewer-undefined') {
                event.preventDefault();
              }
            },
          }),
          pluginImage({ disableTransition:true }),
          pluginVideo(),
          pluginIndent(),
          pluginAudio({
            getAudioUrl: (src) => `https://static.wixstatic.com/${src.id}`,
          }),
          pluginGallery({ disableExpand: true }),
          pluginGiphy(),
          pluginMap(),
          pluginVerticalEmbed(),
          pluginLinkPreview(),
          pluginLineSpacing(),
          pluginEmoji(),
          pluginFileUpload({
            resolveFileUrl: this.resolveFileUrl(),
            downloadTarget: '_blank',
          }),
          pluginDivider(),
          pluginHtml({
            width: '100%',
            minWidth: '100%',
            siteDomain:
              'https://zaherk6.wixsite.com/faq-client-v3-stage/services',
          }),
          pluginLinkButton(),
          pluginTable(),
          pluginTextColor(),
        ]}
        locale={locale}
        content={ensureRicosContent(validContent)}
        biSettings={biSettings}
        theme={{
          parentClass: this.props.parentClass,
        }}
      />
    );
  }
}

export default RCV;
